module.exports = __webpack_public_path__ + "img/scount-middle.33d074c8.svg";